import axios from 'axios';
import { maintenanceEmitter } from './maintenanceBus';
import { signOutLocally } from './utils';

const api = axios.create(); // create a reusable axios instance for API calls

let tokenExpiryHandled = false;

api.interceptors.response.use(
  (res) => res, // let successful responses pass through untouched
  (err) => {
    const status = err?.response?.status;

    if (status === 503) {
      maintenanceEmitter.emit('maintenance-on'); // if the backend returns a 503 (Service Unavailable), notify the app to switch to maintenance mode
    }

    const data = err?.response?.data || {};
    const msg = (data.message || data.error || '').toLowerCase(); // get the error message
    const wwwAuth =
      err?.response?.headers?.['www-authenticate']?.toLowerCase?.() || ''; // get the standard WWW-Authenticate header (if present) to detect token expiry

    const isExpired401 =
      status === 401 &&
      (msg.includes('jwt expired') || wwwAuth.includes('expired')); // check if the jwt has expired

    if (isExpired401 && !tokenExpiryHandled) {
      // if the users jwt token expired:
      tokenExpiryHandled = true; // guard against multiple redirects in flight

      (async () => {
        await signOutLocally(); // remove stored session info, and design_state and all cart items from the users localStorage (and indexedDB) if they are based on restricted products (custom layouts)
        window.location.href = '/signin'; // redirect to sign-in page
      })();
    }

    return Promise.reject(err); // pass the error along for any other handlers
  }
); // this api interceptor catches the "401 jwt expired" error and automatically loggs the user out. It also catches the "503 Service Unavailable" error in responses, which is used for maintenance mode. If any API call receives a 503, this logic emits a 'maintenance-on' event using maintenanceEmitter. The frontend is listening for this event (in components/general/MaintenanceGate.js), so it can immediately show the maintenance screen without waiting for the next /api/status poll.

api.interceptors.request.use((config) => {
  const token = JSON.parse(localStorage.getItem('userInfo') || '{}')?.token; // get the user's auth token from localStorage

  if (token) {
    config.headers.Authorization = `Bearer ${token}`; // If a token exists, attach it as a Bearer token to the request headers
  }

  return config; // return the updated config so the request proceeds
}); // this api interceptor automatically attaches the auth token to every request sent through this api instance (so I don’t need to manually add Authorization headers in every single request).

export default api;
